import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import QuickAddToCart from 'yoda-site-components/lib/components/QuickAddTocart/QuickAddToCart';

import * as styles from './MiniPDPInterstitial.css';

const cx = classNames.bind(styles);

export default class EventListener extends PureComponent {
    // eslint-disable-line react/prefer-stateless-function
    render() {
        return (
            <QuickAddToCart
                miniPDPTriggerEvent="miniPDP.open"
                location="EventListener"
                enableMiniPDP
                themeConfig={{
                    wrapperClass: cx(styles['quick-add-to-cart']),
                }}
            />
        );
    }
}
